import {createContext, useContext, useMemo} from 'react';
import {useLocation} from 'react-router';

import {navPosition} from './mapsight-glue/routing/nav-pos';


/**@type {import("react").Context<import('../stade/types').Magic>} */
export const MagicContext = createContext({});
MagicContext.displayName = 'MagicContext';

export const SSRContext = createContext({});
SSRContext.displayName = 'SSRContext';


export function useSSR() {
	return useContext(SSRContext);
}
export function useIsSSR() {
	return useSSR()?.isSSR;
}

/**
 * @returns {import('./stade/types').Magic}
 */
export function useMagic() {
	return useContext(MagicContext);
}

export function useNavPos() {
	const magic = useMagic();
	const location = useLocation();
	return useMemo(
		() => navPosition(magic, location.pathname, location.state),
		[magic, location.pathname, location.state],
	);
}
